window.process = {
  env: import.meta.env
}
if (!window.global) {
  window.global = window
}
import CoreuiVue from "@coreui/vue-pro"
import App from "./App.vue"
import router from "./router/index"
import store from "./store/index"
//TODO:Fix translations
import i18n from "@/i18n/index.js"
import axios from "axios"
import helpers from "@/helpers/index.js"
import { isLoginPagePath } from "@/configs/authLoginConfig.js"
import download from "./helpers/downloadCSV"
import CIcon from "@coreui/icons-vue"
import SidebarIcon from "@/v3components/Sidebar/SidebarIcon.vue"
import { iconsSet as icons } from "@/assets/icons"
import VueSelect from "vue-select"
import "vue-select/dist/vue-select.css"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import CustomTimePicker from "@/v3components/shared/Form/CustomTimePickerOld.vue"
import DataTable from "@/v3components/shared/DataTable/DataTable.vue"
import DataTableOptimized from "@/v3components/shared/DataTable/DataTableOptimized.vue"
import CustomScrollbar from "@/v3components/CustomScrollbar.vue"
import CCheckBox from "@/v3components/shared/Form/CCheckBoxOld.vue"
import { PerfectScrollbarPlugin } from "@donatix/vue3-perfect-scrollbar"
import "@donatix/vue3-perfect-scrollbar/style.css"
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css"
import { version } from "../package"
import moment from "moment-timezone"
import tokenService from "@/helpers/tokenService.js"
import { createApp } from "vue"
import { setupCalendar, Calendar, DatePicker } from "v-calendar"
import "v-calendar/dist/style.css"
import VueVirtualScroller from "vue-virtual-scroller"
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
import Pagination from "@/v3components/shared/DataTable/PaginationOld.vue"
import VueDatePicker from "@vuepic/vue-datepicker"
import modal from "./plugins/modal"
import actionDialog from "./plugins/actionDialog"
import InOutColumn from "@/v3components/shared/PassComponents/InOutColumn.vue"
import HighchartsVue from "highcharts-vue"
import FloatingVue from "floating-vue"
import "floating-vue/dist/style.css"
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import MaintenanceMode from "@/v3components/shared/Modal/MaintenanceMode.vue"
import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk"
import faroConfig from "@/configs/faroConfig.js"
import { TracingInstrumentation } from "@grafana/faro-web-tracing"
import { initScrollLockLayoutAlign } from "@/helpers/scrollLockLayoutAlign.js"
import {
  announce as announceStatus,
  initLiveAnnouncer
} from "@/composables/useLiveAnnouncer"
import { initAcsbApp } from "@/helpers/initAcsbApp.js"
import analyticsService from "@/helpers/analyticsService"
import { initAccessibeModalGuard } from "@/helpers/accessibeModalGuard.js"

if (faroConfig?.url) {
  try {
    initializeFaro({
      url: faroConfig.url,
      app: {
        name: faroConfig.app?.name,
        version: faroConfig.app?.version || version
      },
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: true }),
        new TracingInstrumentation({})
      ]
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to initialize Grafana Faro:", error)
  }
}

initAccessibeModalGuard()
initAcsbApp()
analyticsService.initAnalytics()

library.add(fas)

const init = () => {
  const app = createApp(App)
  app.use(router)
  app.use(store)
  app.use(VueVirtualScroller)
  app.use(i18n)
  app.use(CoreuiVue)
  app.use(PerfectScrollbarPlugin)
  app.use(modal)
  app.use(actionDialog)
  app.provide("icons", icons)
  app.component("CIcon", CIcon)
  app.component("SidebarIcon", SidebarIcon)
  app.component("FontAwesomeIcon", FontAwesomeIcon)
  app.component("CustomTimePicker", CustomTimePicker)
  app.component("CCheckBox", CCheckBox)
  app.component("DataTable", DataTable)
  app.component("DataTableOptimized", DataTableOptimized)
  app.component("CustomScrollbar", CustomScrollbar)
  app.component("VSelect", VueSelect)
  app.use(setupCalendar, {})
  app.use(Toast)
  /* Announce all toast status messages to screen readers (axe: status-msg-not-auto-announced).
     Wraps the global $toast so any `this.$toast.*` call also updates a persistent live region. */
  const baseToast = app.config.globalProperties.$toast
  if (baseToast) {
    const toastText = (message) =>
      typeof message === "string"
        ? message
        : message?.props?.message || message?.message || ""
    const wrap = (method, assertive) =>
      function (message, options) {
        announceStatus(toastText(message), assertive ? { assertive: true } : {})
        return method.call(this, message, options)
      }
    const wrapped = function (message, options) {
      announceStatus(toastText(message))
      return baseToast.call(this, message, options)
    }
    Object.assign(wrapped, baseToast)
    if (typeof baseToast.success === "function") {
      wrapped.success = wrap(baseToast.success, false)
    }
    if (typeof baseToast.error === "function") {
      wrapped.error = wrap(baseToast.error, true)
    }
    if (typeof baseToast.info === "function") {
      wrapped.info = wrap(baseToast.info, false)
    }
    if (typeof baseToast.warning === "function") {
      wrapped.warning = wrap(baseToast.warning, true)
    }
    app.config.globalProperties.$toast = wrapped
  }
  app.use(FloatingVue)
  app.use(HighchartsVue)
  app.component("Calendar", Calendar)
  app.component("DatePicker", DatePicker)
  app.component("Pagination", Pagination)
  app.component("InOutColumn", InOutColumn)
  app.component("VueDatePicker", VueDatePicker)
  app.config.globalProperties.$helpers = helpers
  app.config.globalProperties.$download = download

  axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error?.response?.status === 401) {
        store.dispatch("authentication/logOut")
        return Promise.reject(error)
      }
      if (error?.response?.status === 503) {
        app.config.globalProperties.$modal.open(MaintenanceMode, {
          size: "lg",
          hideCloseButton: true,
          title: "Maintenance Mode",
          props: {}
        })
        setTimeout(() => {
          store.dispatch("authentication/logOut")
          return Promise.reject(error)
        }, 10000)
      }
      return Promise.reject(error)
    }
  )
  app.directive("noautofill", {
    // When the bound element is inserted into the DOM...
    bind: function (el) {
      const elem = el.childNodes[1]
      elem.setAttribute("readonly", true)
      elem.setAttribute("autocomplete", "new-password")
      elem.addEventListener("focus", (event) => {
        event.target.removeAttribute("readonly")
      })
    }
  })
  app.directive("noautofillinput", {
    // When the bound element is inserted into the DOM...
    bind: function (el) {
      el.setAttribute("readonly", true)
      el.setAttribute("autocomplete", "new-password")
      el.addEventListener("focus", (event) => {
        event.target.removeAttribute("readonly")
      })
    }
  })
  app.mount("#app")
  initLiveAnnouncer()
  initScrollLockLayoutAlign()
}
clearInterval(window.globalTimeInterval)
window.globalTimeInterval = setInterval(() => {
  store.commit("layout/setGlobalTime", moment().format())
}, 1000)

if (import.meta.env.VITE_DD_ENV === "production") {
  document.addEventListener("contextmenu", (e) => {
    e.preventDefault()
  })
}

// Get user data before init if user is logged in
// Function witch check if session is expired
function handleVisibilityChange() {
  const sessionEnd = localStorage.getItem("sessionEnd")
  if (
    !document.hidden &&
    sessionEnd &&
    moment().isAfter(moment(sessionEnd)) &&
    !isLoginPagePath(window.location.pathname)
  ) {
    store.dispatch("authentication/logOut")
    localStorage.removeItem("accessToken")
    localStorage.removeItem("devAccessToken")
    localStorage.removeItem("logoutTime")
    localStorage.removeItem("sessionEnd")
  }
}
// Check for visibility change
document.addEventListener("visibilitychange", handleVisibilityChange)
// After user return to page after browser is minimize check if session is expired and rerun visibility listener
window.addEventListener(
  "focus",
  () => {
    handleVisibilityChange()
    document.addEventListener("visibilitychange", handleVisibilityChange)
  },
  false
)

if (tokenService.getToken()) {
  store
    .dispatch("authentication/getUserDetails", { clearCacheEntry: true })
    .finally(() => {
      store.dispatch("authentication/getAudioPreferences")
      store.dispatch("dashboardTable/getUsersAssignedRooms")

      const user = store.getters["authentication/user"]
      if (user && user.role_id !== 1) {
        store.dispatch("authentication/getUserInitialUnavailability")
      }
      store.dispatch("schools/getSchools").then(() => {
        store.dispatch("schools/getActiveModules").then(() => {
          init()
        })
      })
    })
} else {
  init()
}
